import type React from "react";

import { AddButton } from "./NoResults.style";

interface AddItemProps {
    onAddItem?: () => void;
    onAddItemButtonText?: string;
    isDisabled: boolean;
}

export const AddItem: React.FC<AddItemProps> = ({ onAddItem, onAddItemButtonText, isDisabled }) => (
    <AddButton isDisabled={isDisabled} onClick={onAddItem} type="primary">
        {onAddItemButtonText}
    </AddButton>
);
